module.exports = __webpack_public_path__ + "static/media/chatbubble.1b2e8805.svg";